import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

import { USERS_PATHS } from '../users';
import { BreadcrumbsService } from '../../../shared/breadcrumbs/breadcrumbs.service';

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'app-users-create',
  templateUrl: './users-create.component.html',
  styleUrls: ['./users-create.component.scss'],
  standalone: false,
})
export class UsersCreateComponent implements OnInit {
  collaboratorsBreadcrumbs = [
    { text: 'Сотрудники', url: USERS_PATHS.users },
    { text: 'Регистрация сотрудника', url: null },
  ];

  constructor(private breadcrumbsService: BreadcrumbsService) {}

  ngOnInit() {
    this.breadcrumbsService.updateBreadcrumbs(this.collaboratorsBreadcrumbs);
  }
}
